<cli-topbar></cli-topbar>
<cli-navbar *ngIf="!vm.isOpening" [selectedSection]="'vehicles'" [businessName]="vm.businessName" [permitNo]="vm.permitNo"></cli-navbar>
<core-spinner *ngIf="vm.isLoading"></core-spinner>
<div class="container" *ngIf="!vm.isOpening">
    <div class="row ">
        <div class="col-md-6 section-header">Vehicles</div>
        <div class="col-md-6 text-right">
          <button class="btn btn-link btn-sm" (click)="downloadCsv()"><i class="fas fa-download"></i> Download</button>
        </div>
    </div>

    <div class="row ">
        <div class="col pt-2 section-subheader">Active Vehicles
            <span *ngIf="vm.activeVehicles && vm.activeVehicles.length>0">({{vm.activeVehicles.length}})</span>
        </div>
        <div class="col  d-flex justify-content-end">
                <div *ngIf="vm.isRenewable && vm.status=='Active'"><button class="btn btn-link pb-1" type="button" (click)="renewPermit()">Renew Permit</button></div>
                <div *ngIf="!vm.isExpired && vm.status=='Active'"><button class="btn btn-link pb-1" type="button" (click)="addVehicle()">Add Vehicle</button></div>
        </div>
    </div>
    <div>
        <hr class="mt-0" />
    </div>
    <div *ngIf="vm.activeVehicles.length==0">
        No active vehicles found
    </div>
    <div class="row">
        <div class="col-sm-12 col-md-10 col-lg-8 pb-2" *ngFor="let v of vm.activeVehicles">
            <cli-vehicle-details [vehicle]="v"></cli-vehicle-details>
        </div>

    </div>

    <div *ngIf="vm.expiredVehicles.length>0">
        <div class="row section-subheader">
            <div class="col pt-2">Inactive Vehicles
                <span *ngIf="vm.expiredVehicles && vm.expiredVehicles.length>0">({{vm.expiredVehicles.length}})</span></div>
        </div>
        <div>
            <hr class="mt-0" />
        </div>
        <div class="row">

            <div class="col-6 pb-2" *ngFor="let v of vm.expiredVehicles">
                <cli-vehicle-details [vehicle]="v"></cli-vehicle-details>
            </div>

        </div>

    </div>
</div>
